import { render, staticRenderFns } from "./Auftraege_Abgelehnt.vue?vue&type=template&id=4b1de458&scoped=true"
import script from "./Auftraege_Abgelehnt.vue?vue&type=script&lang=js"
export * from "./Auftraege_Abgelehnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1de458",
  null
  
)

export default component.exports